app.controller('DashboardController', ['$rootScope', '$scope', '$state', 'bowser', function ($rootScope, $scope, $state, bowser) {

    $scope.show_ie_message = !!(bowser.msie && bowser.version <= 11);

    $scope.advert_slides = [];

    function initFeaturedAdverts() {
        $scope.advert_slide_interval = 5000;
        $scope.advert_slides = [];

        const dataApiService = $rootScope.service.data_api;

        const data_api_model = dataApiService.factory.getModel({data_api_id: 'article'});
        const categorySlug = 'featured-adverts';

        data_api_model.requireCategoryPostList(categorySlug, function () {
            const category = data_api_model.categories[categorySlug];
            if (category) {
                for (let i = 0; i < category.post_list.length; i++) {
                    const post = category.post_list[i];
                    const title = post.title && post.title.rendered ? post.title.rendered : "";
                    const content_layout = post.acf && post.acf.content_layouts && post.acf.content_layouts.length > 0 ? post.acf.content_layouts[0] : null;
                    const image = content_layout && content_layout.images && content_layout.images.length > 0 ? content_layout.images[0] : null;
                    const size = image && image.sizes ? image.sizes["large-landscape"] : null;
                    if (size) {
                        $scope.advert_slides.push({
                            title: title,
                            image: size
                        });
                    }
                }
            }
        });
    }

    function initOrderSubmittedHistory() {
        const limit = 12;

        const orderHistoryModel = $rootScope.service.order_history.getSubmittedModel(limit)

        $scope.order_submitted_list_model = new $rootScope.model_constructor.ListModel({
            item_list: orderHistoryModel.choiceList(),
            in_progress: true
        });

        orderHistoryModel.requestOrders(function () {
            $scope.order_submitted_list_model.cloneList(orderHistoryModel.choiceList());
        })

        $scope.showOrderSubmitted = function (order) {
            $state.go('myba.order-history-submitted-entry.entry', {order_id: order.id});
        };
    }

    function initOrderWebHistory() {

        const limit = 12;

        const orderHistoryModel = $rootScope.service.order_history.getWebModel(limit)


        $scope.order_web_list_model = new $rootScope.model_constructor.ListModel({
            item_list: orderHistoryModel.choiceList(),
            in_progress: true
        });

        orderHistoryModel.requestOrders(function () {
            $scope.order_web_list_model.cloneList(orderHistoryModel.choiceList());
        })

        $scope.showOrderWeb = function (order) {
            $state.go('myba.order-history-web-entry.entry', {order_id: order._id});
        };
    }


    initFeaturedAdverts();
    initOrderSubmittedHistory();
    initOrderWebHistory();

}]);